import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import TilesSection from '../tiles/TilesSection';
import MapSection from '../map/MapSection';
import usePaginationScroll from '../../hooks/usePaginationScroll';
import { usePaginationContext } from '../../contexts/PaginationContext';
import {
	DEFAULT_MAP_ZOOM,
	DEFAULT_MAP_CENTER
} from '../../constants/mapConstants';
import '../../global-sass/main.scss';

const LocationLayout = ({ tileData, showMap, coordinates }) => {
	const { currentPage } = usePaginationContext();
	const { scrollTargetRef } = usePaginationScroll(currentPage);
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';
	const shouldShowMap = showMap && !isMobile;

	// Determine map center: use coordinates from search, or first location, or default
	const firstLocation = tileData[0]?.location || tileData[0];
	const mapCenter =
		coordinates ||
		(firstLocation?.latitude && firstLocation?.longitude
			? { lat: firstLocation.latitude, lng: firstLocation.longitude }
			: DEFAULT_MAP_CENTER);

	const containerClassNames = setClassNames([
		'location-layout',
		'mx-auto',
		'p-4',
		'p-lg-5'
	]);

	const tilesClassNames = setClassNames([
		'flex-fill',
		'mb-4',
		'pr-0',
		shouldShowMap ? 'pr-8' : ''
	]);

	return (
		<div className={containerClassNames} data-testid="location-layout">
			<div className="d-flex flex-column flex-lg-row w-100">
				<div
					className={tilesClassNames}
					style={{ minWidth: 0 }}
					ref={scrollTargetRef}
				>
					<TilesSection tileData={tileData} />
				</div>

				{shouldShowMap && (
					<MapSection
						center={mapCenter}
						zoom={DEFAULT_MAP_ZOOM}
						locations={tileData}
					/>
				)}
			</div>
		</div>
	);
};

LocationLayout.propTypes = {
	tileData: PropTypes.arrayOf(PropTypes.object).isRequired,
	showMap: PropTypes.bool.isRequired,
	coordinates: PropTypes.shape({
		lat: PropTypes.number.isRequired,
		lng: PropTypes.number.isRequired
	})
};

export default LocationLayout;
